import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import { dateTime } from '@savantly/sprout-api';
import { css, cx } from 'emotion';
import { useField, useFormikContext } from 'formik';
import React, { Fragment } from 'react';
import Datetime from 'react-datetime';
var DateTimeWrapper = function (_a) {
    var dateControlProps = _a.dateControlProps, onChange = _a.onChange, value = _a.value, dateFormat = _a.dateFormat, timeFormat = _a.timeFormat;
    return (React.createElement(Datetime, __assign({}, dateControlProps, { value: value, onChange: onChange, closeOnSelect: true, dateFormat: dateFormat, timeFormat: timeFormat })));
};
export var DateTimeField = function (_a) {
    var name = _a.name, label = _a.label, _b = _a.dateValueFormat, dateValueFormat = _b === void 0 ? 'YYYY-MM-DD' : _b, _c = _a.timeValueFormat, timeValueFormat = _c === void 0 ? 'HH:mm:ssZ' : _c, _d = _a.dateDisplayFormat, dateDisplayFormat = _d === void 0 ? 'YYYY-MM-DD' : _d, _e = _a.timeDisplayFormat, timeDisplayFormat = _e === void 0 ? 'hh:mm:ss A' : _e, _f = _a.dateTimeValueSeparator, dateTimeValueSeparator = _f === void 0 ? 'T' : _f, onChange = _a.onChange, dateControlProps = __rest(_a, ["name", "label", "dateValueFormat", "timeValueFormat", "dateDisplayFormat", "timeDisplayFormat", "dateTimeValueSeparator", "onChange"]);
    var setFieldValue = useFormikContext().setFieldValue;
    var _g = __read(useField(name), 1), field = _g[0];
    var formatInternalValue = function (val) {
        if (typeof val === 'string') {
            var _value = dateTime(val) || dateTime();
            return _value.format("" + dateValueFormat + dateTimeValueSeparator + timeValueFormat);
        }
        else {
            return val.format("" + dateValueFormat + dateTimeValueSeparator + timeValueFormat);
        }
    };
    var _pickerOnChange = function (val) {
        if (field.value !== val) {
            setFieldValue(field.name, formatInternalValue(val));
        }
    };
    var formatDisplayValue = function () {
        if (typeof field.value === 'string') {
            console.log('formatting value', field.value);
            var _value = dateTime(field.value) || dateTime();
            return _value.format(dateDisplayFormat + " " + timeDisplayFormat);
        }
        else {
            return undefined;
        }
    };
    var displayValue = formatDisplayValue();
    return (React.createElement(Fragment, null,
        React.createElement("div", { key: field.name, className: cx('col', css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            flex-direction: column;\n            display: inline-grid;\n          "], ["\n            flex-direction: column;\n            display: inline-grid;\n          "])))) },
            React.createElement("label", null, label),
            React.createElement(DateTimeWrapper, { onChange: _pickerOnChange, dateFormat: dateDisplayFormat, timeFormat: timeDisplayFormat, value: displayValue, dateControlProps: dateControlProps }))));
};
var templateObject_1;
//# sourceMappingURL=DateTimeField.js.map